import React from 'react';

type ToastItem = {
  id: string;
  type: 'success' | 'error' | 'info';
  message: string;
  autoDismiss: boolean;
};

type ToastProps = {
  toasts: ToastItem[];
  onDismiss: (id: string) => void;
};

function Toast({ toasts, onDismiss }: ToastProps) {

  if (toasts.length === 0) {
    return null;
  }

  return (
    <div
      style={{
        position: 'fixed',
        right: 16,
        bottom: 16,
        zIndex: 3000,
        display: 'grid',
        gap: 8,
        width: 320,
        maxWidth: 'calc(100vw - 32px)',
      }}
    >
      {toasts.map((toast) => (
        <div
          key={toast.id}
          style={{
            borderRadius: 8,
            padding: '10px 12px',
            color: '#ffffff',
            background:
              toast.type === 'success'
                ? '#2e7d32'
                : toast.type === 'error'
                ? '#c62828'
                : '#1565c0',
            boxShadow: '0 8px 20px rgba(0,0,0,0.2)',
          }}
        >
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 8 }}>
            <span>{toast.message}</span>
            <button
              type="button"
              onClick={() => {
                onDismiss(toast.id);
              }}
              style={{
                border: 0,
                background: 'transparent',
                color: '#ffffff',
                cursor: 'pointer',
                fontWeight: 700,
              }}
            >
              ×
            </button>
          </div>
        </div>
      ))}
    </div>
  );
}

export default Toast;
